<template>
  <!-- content start -->
  <div class="content custom-quiz" >
    <QuizHeader/>
    <div style="height: 380px;background: var(--bg-color);"></div>
    <div class="quiz-details-block" style="margin-right: 10px; margin-left: 10px; margin-top: -330px" :style="{marginBottom: '70px'}">
      <div class="quiz-image w-full">
        <img :src="game_data.banner_url" alt="quiz">
      </div>

      <!-- Custom Quiz Section Start -->
      <div class="custom-quiz-section w-full" style="margin-top: 15px; margin-bottom: 110px;" v-if="game_data.other_banners.length === 0">

        <div class="detail-header w-full" >
          <div @click="showDetails" :class="[show_detail?'highlight':'']"><span style="font-size: 16px">PRIZE</span></div>
          <div @click="showLeaderBoard" :class="[show_detail?'':'highlight']"><span style="font-size: 16px">LEADERBOARD</span></div>
        </div>
        <!-- Custom Timer Section Start -->
        <div class="custom-timer-section text-center" v-if="show_detail===true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 16px; fill: var(--bg-color)">
            <path d="M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3
             371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4
             0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9
             141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"/>
          </svg>
          <span v-if="game_data.is_live"> Ends in</span>
          <span v-else>Starts in</span>
          <!-- <div class="custom_timer is-countdown" style="margin-top:10px">
            <span class="countdown-row countdown-amount">
              {{ displayDays > 0 ? displayDays + " : " : "" }}{{ displayHours }} : {{ displayMinutes }} : {{ displaySeconds }}
            </span>
          </div> -->
          <div style="display: flex; flex-direction: row; justify-content: center;margin-top:10px;" class="border-bottom padding-bottom-10">
            <div class="is-countdown" style="display: flex; flex-direction: column;" v-if="displayDays > 0">
              <span class="countdown-amount">
                {{ displayDays }}
              </span>
              <span>Days</span>
            </div>
            <div class="is-countdown" style="margin-left: 10px; margin-right: 10px;" v-if="displayDays > 0">
              <span class="countdown-amount">
                :
              </span>
            </div>
            <div class="is-countdown" style="display: flex; flex-direction: column;">
              <span class="countdown-amount">
                {{ displayHours }}
              </span>
              <span>Hrs</span>
            </div>
            <div class="is-countdown" style="margin-left: 10px; margin-right: 10px;">
              <span class="countdown-amount">
                :
              </span>
            </div>
            <div class="is-countdown" style="display: flex; flex-direction: column;">
              <span class="countdown-amount">
                {{ displayMinutes }}
              </span>
              <span>Min</span>
            </div>
            <div class="is-countdown" style="margin-left: 10px; margin-right: 10px;">
              <span class="countdown-amount">
                :
              </span>
            </div>
            <div class="is-countdown" style="display: flex; flex-direction: column;">
              <span class="countdown-amount">
                {{ displaySeconds }}
              </span>
              <span>Sec</span>
            </div>
          </div>

          <!-- Spinner Section Start -->
          <div class="spinner-section padding-top-5" v-for="(item, index) in game_data.other_banners">
            <div v-on:click="handleDeeplink(item.deeplink)" class="spinner-block">
              <img :src="item.image_url" alt="spinner" class="img-fluid">
            </div>
          </div>
          <!-- Spinner Section End -->

          <div class="ranking border-bottom padding-bottom-5 margin-bottom-10" v-if="game_data.other_banners.length === 0">
            <h6 style="color:#373535; font-weight: bolder;font-size: 18px">Rankings</h6>
            <div class="table-responsive-sm">
              <table class="table table-striped">
                <thead>
                <tr><td class="text-left">Rank</td>
                  <td>{{game_data.currency_label}}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="prize in game_data.prizes">
                  <td class="text-left" v-if="prize.from_rank===prize.to_rank">{{prize.to_rank}}</td>
                  <td class="text-left" v-else>{{prize.from_rank}} to {{prize.to_rank}}</td>
                  <td v-if="prize.from_prize===prize.to_prize">{{prize.to_prize}}</td>
                  <td v-else>{{prize.from_prize}} - {{prize.to_prize}}</td>
                </tr>
                <tr>
                  <td style="font-weight: bold; font-size: 16px" class="text-left">Total Price Pool:</td>
                  <td style="font-weight: bold; font-size: 16px">Upto {{getTotalPoolPrize()}}</td>
                </tr>
                </tbody>
              </table>
<!--              <div>{{prize.from_rank}} to {{prize.to_rank}}</div>
              <div>{{prize.from_prize}} to {{prize.to_prize}}</div>-->
            </div>
          </div>

          <div class="details padding-top-10" v-if="game_data.rules && game_data.other_banners.length === 0">
            <h6 style="color: #373535; font-weight: bolder; font-size: 18px">Details</h6>
            <div v-html="game_data.rules" class="rules-text"
                 style="white-space: normal; text-align: -webkit-left; padding:1rem 1.9rem"></div>
          </div>
          <!-- <div class="timer">
            <p>45 <span>h</span></p>
            <p>58 <span>m</span></p>
            <p>00 <span>s</span></p>
          </div> -->
        </div>
        <!-- Custom Timer Section End -->


        <!-- Leader Board Div-->
        <div v-if="show_detail===false" style="min-height: 24rem;">
          <div v-if="game_data.is_live">
            <span style="font-weight: bold; font-size: 16px"> Winners will be announced soon. Please check back Later</span>
          </div>
          <div v-if="!game_data.is_live" class="padding-top-5">
            <span style="font-weight: bold; font-size: 16px"> You have not participated in any quiz yet.</span>
          </div>
        </div>

      </div>
      <!-- Custom Quiz Section End -->

      <div v-else>
        <div class="custom-timer-section text-center">
          <span v-if="game_data.is_live" style="color:#fff"> Ends in</span>
          <span v-else style="color:#fff">Starts in</span>
          <!-- <div class="custom_timer is-countdown" style="margin-top:10px">
            <span class="countdown-row countdown-amount">
              {{ displayDays > 0 ? displayDays + " : " : "" }}{{ displayHours }} : {{ displayMinutes }} : {{ displaySeconds }}
            </span>
          </div> -->
          <div style="color:#fff; display: flex; flex-direction: row; justify-content: center;margin-top:10px;" class="padding-bottom-10">
            <div class="is-countdown" style="display: flex; flex-direction: column;" v-if="displayDays > 0">
              <span class="countdown-amount">
                {{ displayDays }}d
              </span>

            </div>
            <div class="is-countdown" style="margin-left: 10px; margin-right: 10px;" v-if="displayDays > 0">
              <span class="countdown-amount">:
              </span>
            </div>
            <div class="is-countdown" style="display: flex; flex-direction: column;">
              <span class="countdown-amount">
                {{ displayHours }}h
              </span>

            </div>
            <div class="is-countdown" style="margin-left: 10px; margin-right: 10px;">
              <span class="countdown-amount">:
              </span>
            </div>
            <div class="is-countdown" style="display: flex; flex-direction: column;">
              <span class="countdown-amount">
                {{ displayMinutes }}m
              </span>

            </div>
            <div class="is-countdown" style="margin-left: 10px; margin-right: 10px;">
              <span class="countdown-amount">:
              </span>
            </div>
            <div class="is-countdown" style="display: flex; flex-direction: column;">
              <span class="countdown-amount">
                {{ displaySeconds }}s
              </span>

            </div>
          </div>

          <div class="spinner-section padding-top-5" v-for="(item, index) in game_data.other_banners">
            <div v-on:click="handleDeeplink(item.deeplink)" class="spinner-block">
              <img :src="item.image_url" alt="spinner" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="toast" class="font-bold pos-fixed pos-center-hor pull-down"
         style="width: 80%; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.5); margin-bottom: 70px;
         color: white; display: none; z-index: 999;"></div>

    <footer class="footer" style="display: flex;
    flex-direction: row; justify-content: center;
    height: 30px; border-top: 1px solid #EFEFEF;">
      <div class="" style="margin-right: auto;
      margin-left: auto;width: 100%;align-items: center;
      display:flex;justify-content: center;"
           v-if="game_data.is_live && !game_data.has_played">
        <router-link :to="{name: 'quiz_questions', params: {id: game_data.id}}">
          <a class="btn text-uppercase" style="color: #fff; padding: 8px 10px; background: var(--bg-color); width: 150px; height: 20px; border-radius: 50px;" role="button">Play Quiz Now</a>
        </router-link>
      </div>
      <div class="" style="margin-right: auto;margin-left: auto;width: 100%;align-items: center;display: flex;justify-content: center;" v-else-if="!game_data.is_live && !game_data.notified">
        <div v-on:click="notifyUser()" class="btn text-uppercase" style="color: #fff; padding: 8px 0; background: var(--bg-color); width: 150px; height: 20px; border-radius: 50px;" role="button">
          Notify Me
        </div>
      </div>
      <div class="" style="margin-right: 15px; margin-left: 15px;" v-else-if="!game_data.is_live && game_data.notified">
        <div style="color: #fff; padding: 8px 10px; width: 150px; margin: auto; border-radius: 50px;" @click.prevent="game_data.has_played" :class="{ 'disabled': game_data.has_played}"
              :style="{background: game_data.has_played ?'gray': !game_data.is_live ? 'gray' :'var(--bg-color)'}">
          Play Quiz Now
        </div>
      </div>

      <div style="background: var(--bg-color); width: 35px; height: 35px; margin: auto; border-radius: 50%;" v-on:click="sharemessage(game_data.share_message)" v-if="game_data.share_message">
        <img src="@/assets/share.svg" width="17px" style="margin: 7px 6px 5px 5px;">
      </div>
    </footer>
  </div>
    <!-- content end -->
</template>

<script>
// import Tasks from '../components/Tasks'
import QuizHeader from '@/components/quiz-header'
import axios from "axios"
export default {
  name: 'quiz-details-custom',
  props: {
    date: {
      type: String
    }
  },
  components: {
    // Quiz
    // AddTask,
    // Tasks,
    QuizHeader
  },
  data: () => ({
    displayDays: 0,
    displayHours: 0,
    displayMinutes: 0,
    displaySeconds: 0,
    distance: 3600000,
    id: '',
    game_data: '',
    show_detail: true
  }),
  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60
    },
    _hours() {
      return this._minutes * 60
    },
    _days() {
      return this._hours * 24
    },
    is_live() {
      let d1 = new Date();
      let d2 = new Date(this.game_data.starts_at);
      let diff = (d2 - d1);
      if(diff === 0) {
        this.game_data.is_live = true;
      }
      return this.game_data.is_live;
    }
  },
  methods: {
    sharemessage(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      document.getElementById("toast").style.width = "100px";
      document.getElementById("toast").innerHTML = "Copied";
      document.getElementById("toast").style.display = 'block';
      setTimeout(function() {
        document.getElementById("toast").style.width = 80+"%";
        document.getElementById("toast").style.display = 'none';
      }, 2000)
    },
    notifyUser() {
      var self = this;
      var url = self.$store.getters.flyyDomain + '/v1/notify_user/'+self.id+"?notify_type=API";
      var headers = self.$store.getters.headers;
      axios.get(url, {
        headers: headers,
      }).then((resp) => {
        if(resp.status == 200) {
          var data = resp.data;
          // console.log(data)
          this.game_data.notified = true;

          document.getElementsByTagName("footer")[0].getElementsByTagName("div")[0].innerHTML = `<div class="" style="margin-right: 15px; margin-left: 15px;"><div style="color: #fff; padding: 8px 0; background: grey !important; width: 150px; margin: auto; border-radius: 50px;">Play Quiz Now</div></div>`;
          document.getElementById("toast").innerHTML = data.message;
          document.getElementById("toast").style.display = 'block';
          setTimeout(function() {
            document.getElementById("toast").style.display = 'none';
          }, 2000)
        } else {
          console.log("Error Notifying User");
        }
      })
    },
    handleDeeplink(deeplink) {
      // deeplink = "https://www.google.com"
      if (deeplink) {
        window.open(deeplink, '_blank');
      }
    },
    showRemaining() {
      const timer = setInterval(() => {
        if (this.distance < 0) {
          clearInterval(timer);
          return
        }
        const seconds = parseInt(Math.floor(this.distance % this._minutes) / this._seconds);
        const minutes = parseInt(Math.floor(this.distance % this._hours) / this._minutes);
        const days = parseInt(Math.floor(this.distance / this._days));
        const hours = parseInt(Math.floor(this.distance % this._days) / this._hours);


        this.displayMinutes = minutes < 10 ? "0" + minutes : minutes;
        this.displaySeconds = seconds < 10 ? "0" + seconds : seconds;
        this.displayHours = hours < 10 ? "0" + hours : hours;
        this.displayDays = days < 10 ? "0" + days : days;
        this.distance = this.distance - 1000
      }, 1000)
    },
    getTotalPoolPrize() {
      let poolprize = 0;
      this.game_data.prizes.forEach((i)=>{
        let people =0;
        if(i.from_rank===i.to_rank){
          people =1
        } else {
          people = (i.to_rank - i.from_rank)+1;
        }
        poolprize +=people * i.to_prize;
      });
      return poolprize;
    },
    fetchQuizDetails() {
      var self = this;
      var url = self.$store.getters.flyyDomain + '/v2/quiz_game/'+self.id;
      var headers = self.$store.getters.headers;
      axios.get(url, {
        headers: headers,
      }).then((resp) => {
        if(resp.status == 200) {
          var data = resp.data;
          // console.log(data)
          self.game_data = data.game;
          this.$store.state.quizDetailsTitle = self.game_data.title;
          var now = new Date();
          var end = new Date(self.game_data.starts_at);

          if (self.game_data.is_live) {
            now = new Date();
            end = new Date(self.game_data.ends_at);
          }

          self.distance = end - now;
          self.showRemaining();
        } else {
          console.log("Error fetching the Quiz Details");
        }
      })
    },
    showDetails() {
      this.show_detail = true
    },
    showLeaderBoard() {
      this.show_detail = false
    }
  },
  async created() {
    // this.$emit('handleShowFooter', true);
    if (this.$route.params.id) {
      this.$store.state.quizDetailsId = this.$route.params.id;
    }
    this.id = this.$store.state.quizDetailsId

  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = true;
    this.fetchQuizDetails();
  },
  watch: {
    distance : function (val) {
      if(val<=0){
        this.fetchQuizDetails();
      }
    }
  }
}
</script>

<style scoped>
  @import '../assets/quiz-styles/quiz-styles.css';
  @import '../assets/quiz-styles/bootstrap.css';
  @import '../assets/fonts/quiz-fonts/fonts.css';

  .custom-quiz-section {
    background: #FFFFFF;
    border-radius: 5px;
  }
  .quiz-details-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .w-full {
    width: 100% !important;
  }

  .detail-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .detail-header > div {
    width: 50%;
    padding: 10px 1px;
  }
  .detail-header > span {
    color: var(--bgcolor);
  }

  .ranking {
    padding: 0.75rem;
    margin: 0.25rem;
  }

  .rules-text {
    overflow-x: scroll;
  }
  .rules-text span {
    white-space: normal !important;
  }

  .highlight {
    border-bottom: 1px solid var(--bg-color);
  }
</style>



// WEBPACK FOOTER //
// src/screens/quiz-details-custom.vue